import { useRef } from 'react';
import { useInView, useReducedMotion, useTypedOnce } from '../motion.ts';

/**
 * "Give your agent clear boundaries." — and then the boundary is performed once,
 * as the film does it: a question is asked, an approved answer arrives with its
 * tick, and then a question nobody approved an answer for gets the honest
 * reply, typed. It plays when the card is on screen and holds its last frame.
 */
const QUESTION = 'Does the demo need access to our live app?';
const REFUSAL = 'I don’t have an approved answer for that.';

export function Gate() {
  const card = useRef<HTMLDivElement>(null);
  const reduced = useReducedMotion();
  const seen = useInView(card, 0.45);
  const asked = useTypedOnce(QUESTION, seen, 150, 26);
  const done = asked.length >= QUESTION.length;
  const refused = useTypedOnce(REFUSAL, seen && done, 1700, 30);
  return <section className="control-section wrap" id="gate">
    <div className="control-copy">
      <p className="eyebrow">Your product. Your words.</p>
      <h2 className="h2 section-title">Give your agent<br /><em>clear boundaries.</em></h2>
      <p className="lead">Decide what it can show and what it can say. Review the claims before they become part of a buyer’s conversation.</p>
      <a href="#studio" className="text-link">Explore the workspace <span aria-hidden="true">↗</span></a>
    </div>
    <div className="control-example gate-play" ref={card} data-play={seen || reduced ? '' : undefined}>
      <div className="control-example-head"><span>AN APPROVED ANSWER</span><span className="example-label">Illustrative exchange</span></div>
      <p className="buyer-question" aria-label={QUESTION}><span aria-hidden="true">“{asked}{!done && !reduced && seen && <i className="hs-caret dark"/>}{done ? '”' : ''}</span></p>
      <div className="agent-answer"><img src="/agent-thinking.svg" alt=""/><div><span className="answer-label">PERSIVO</span><p>“The demo runs on a recorded copy of your product.”</p><span className="approved-label">✓ Approved by your team</span></div></div>
      <div className="control-boundary"><span>When the answer isn’t approved</span><p aria-label={REFUSAL}><span aria-hidden="true">“{refused}{refused.length >= REFUSAL.length ? '”' : ''}</span></p></div>
    </div>
  </section>;
}
